import { Globe2, ListChecks, Share2 } from "lucide-react";
import { login } from "@/hooks/useAuth";
import { EmailSignIn } from "@/components/auth/EmailSignIn";

const HERO = "https://images.unsplash.com/photo-1562504208-03d85cc8c23e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

const Feature = ({ icon: Icon, title, text, color }) => (
  <div className="flex gap-3">
    <Icon size={18} style={{ color }} className="mt-0.5 shrink-0" />
    <div>
      <p className="font-medium">{title}</p>
      <p className="text-sm text-slate-400">{text}</p>
    </div>
  </div>
);

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 grain relative overflow-hidden" data-testid="landing-page">
      <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F17] via-[#0B0F17]/90 to-[#0B0F17]/40" />
      <div className="relative px-6 sm:px-12 lg:px-20 py-10 min-h-screen flex flex-col">
        <p className="font-display font-bold tracking-tight text-lg">the bucketlist<span className="text-emerald-400">.</span></p>
        <div className="flex-1 flex flex-col justify-center max-w-2xl py-16">
          <p className="eyebrow animate-rise">One life · one map</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight mt-4 animate-rise" style={{ animationDelay: "80ms" }}>
            Paint the world <span className="text-emerald-400">green.</span>
          </h1>
          <p className="text-slate-300 mt-6 text-base sm:text-lg max-w-lg animate-rise" style={{ animationDelay: "160ms" }}>
            Mark every country and city you've been to, line up where you're going next, and keep the list of things you want to do before you die.
          </p>
          <button onClick={login} data-testid="google-login-button"
            className="mt-10 self-start flex items-center gap-3 rounded-full bg-white text-[#0B0F17] pl-2 pr-6 py-2 font-medium hover:bg-emerald-300 transition-colors duration-200 animate-rise" style={{ animationDelay: "240ms" }}>
            <span className="w-9 h-9 rounded-full bg-[#0B0F17] grid place-items-center text-white font-display font-bold">G</span>
            Continue with Google
          </button>
          <EmailSignIn className="mt-4 self-start animate-rise" />
          <p className="mt-1 text-xs text-slate-400 animate-rise">Google keeps signing you into the wrong account? Use an email code to pick the right one.</p>
          <div className="grid sm:grid-cols-3 gap-6 mt-16 animate-rise" style={{ animationDelay: "320ms" }}>
            <Feature icon={Globe2} color="#34D399" title="Your world map" text="Countries and cities, shaded as you go." />
            <Feature icon={ListChecks} color="#FB7185" title="Before I die" text="Goals with dates, notes and categories." />
            <Feature icon={Share2} color="#F59E0B" title="Share it" text="A view-only link for friends." />
          </div>
        </div>
      </div>
    </div>
  );
}
